export default String.raw`
{% include 'partials/common/date-format.html' -%}	

{% assign loyaltyHistory = customer-profile.LoyaltyHistory -%}
{% assign orderString = customer-profile.OrderQueryGET -%}
{% assign paginationPageNo = loyaltyHistory.PageNo -%}

<div class="loyalty-history-js">
	<div class="customer-submenu">
		<div class="customer-submenu__header">
			{{translations.LoyaltyProgram}}
			{% if customer.Points != 0 -%}
				<button aria-label="{{translations.ExchangePointsForProducts}}" class="primary-action-button find-products-with-points-js" data-url="{{ page.BaseHref }}{{config.DefinedPages.ProductList.Url}}">
					{{ translations.ExchangePointsForProducts }}
				</button>
			{% endif -%}
		</div>
		<div class="order-details">
			<div class="order-details__row">
				<div class="order-details-item">
					<div class="title">{{ translations.PointsToUse }}:</div>
					<span><strong>{{customer.Points}}</strong></span>
				</div>
			</div>
		</div>
		<div class="eshop__table-container">
			<table>
				<colgroup>
					<col style="width:140px">
					<col style="width:160px">
					<col style="width:140px">
				</colgroup>
				<thead>
					<tr>
						<th class="id">{{ translations.PointsQuantity }}</th>
						<th>{{ translations.PointsSource }}</th>
						<th>{{ translations.Date }}</th>
					</tr>
				</thead>
				{% if loyaltyHistory.TotalItems > 0 -%}
					<tbody>
						{% for item in loyaltyHistory.Items -%}
							<tr>
								<td class="id">
									{% if item.Points > 0 -%}
										<span class="success">+{{ item.Points | ToString }}</span>
									{% elseif item.Points < 0 -%}
										<span class="error">{{ item.Points }}</span>
									{% endif -%}
								</td>
								<td>
									<div tabindex="0" role="button" aria-label="{{item.EventText}}" class="pure-button load-deeper-lvl-js parent-container-reload-js open-order-details-js" data-id="{{ item.Id }}" data-url="{{ page.Url }}?{{ orderString | H }}={{ item.Id }}&deeper-lvl&tab=order-details" data-template="partials/customer-profile/orders/order-details.html">
										{{ item.EventText }} {{ item.Id }}
									</div>
								</td>
								<td>
									{{ item.Date | Date:dateFormat }}
								</td>
							</tr>
						{% endfor -%}
					</tbody>
				{% endif -%}
			</table>
		</div>
		{% if loyaltyHistory.TotalItems > 0 -%}
			{% include 'partials/common/pagination.html' -%}
		{% else -%}
			<div class="no-data">{{ translations.NoOrders }}</div>
		{% endif -%}
	</div>
</div>
`